import { useEffect, useState } from "react";

import { useCanUseProBuyerProjects } from "@/features/pro-buyer-projects/components/ProProjectsGate";
import { PRO_PROJECTS_FIRST_SEEN_STORAGE_KEY } from "@/features/pro-buyer-projects/static/pro-buyer-projects.static";
import { isProProjectsNewLabelVisible } from "@/features/pro-buyer-projects/utils/pro-projects.utils";

/** First time this browser showed the menu item to this member; stored on first sight. */
const readFirstSeen = (memberId: string, now: number): number => {
  const key = `${PRO_PROJECTS_FIRST_SEEN_STORAGE_KEY}:${memberId}`;

  try {
    const stored = Number(window.localStorage.getItem(key));

    if (Number.isFinite(stored) && stored > 0) {
      return stored;
    }

    window.localStorage.setItem(key, String(now));
  } catch {
    // Storage blocked: treat this view as the first one, so the pill shows.
  }

  return now;
};

/**
 * WHO-5959 6b, spec S1. The pink "Nieuw" pill on the menu item for 30 days
 * after it first appeared for this account (per browser: there is no server
 * record of it). Never for a read-only (switched-off) Pro Buyer.
 */
export const useProProjectsNewLabel = () => {
  const { canUse, readOnly, memberId } = useCanUseProBuyerProjects();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!canUse || readOnly || !memberId) {
      setVisible(false);

      return;
    }

    const now = Date.now();

    setVisible(isProProjectsNewLabelVisible(readFirstSeen(memberId, now), now));
  }, [canUse, readOnly, memberId]);

  return visible;
};
